export function PeriodTheDataWillBeStored() {
  return (
    <p>
      We will retain your Personal Data for as long as you are a member with us or as otherwise necessary to provide you the services. We will also retain your Personal Data as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements. Some data may also be stored longer than the stated retention period for the purposes of business continuity.
      <br />
      <br />
      Where we no longer need to process your Personal Data for the purposes set out in this Privacy Policy, we will delete your Personal Data from our systems.
    </p>
  );
}

export default PeriodTheDataWillBeStored;
